import moment from "moment";
import { Calendar } from "primereact/calendar";
import { useEffect, useRef, useState } from "react";
import { IsNullOrUndefined } from "../../../utils/null-check";

function LastUpdatedDateFilter({
    startDate,
    endDate,
    updateDateCB,
}: {
    startDate: string | null;
    endDate: string | null;
    updateDateCB: (startDate: string | null, endDate: string | null) => void;
}) {
    const calendarRef = useRef<Calendar>(null);
    const [fromDate, setFromDate] = useState<Date | null | undefined>(
        startDate ? new Date(startDate) : null
    );
    const [toDate, setToDate] = useState<Date | null | undefined>(
        endDate ? new Date(endDate) : null
    );

    useEffect(() => {
        setFromDate(startDate ? new Date(startDate) : null);
        setToDate(endDate ? new Date(endDate) : null);
    }, [startDate, endDate]);

    const emitDateChange = (
        nextFromDate: Date | null | undefined,
        nextToDate: Date | null | undefined
    ): void => {
        const formattedFrom = nextFromDate
            ? moment(nextFromDate).format("YYYY-MM-DD")
            : null;
        const formattedTo = nextToDate
            ? moment(nextToDate).format("YYYY-MM-DD")
            : null;
        updateDateCB(formattedFrom, formattedTo);
    };

    return (
        <div className="d-flex flex-column gap-1">
            <Calendar
                value={fromDate}
                dateFormat="dd/mm/yy"
                placeholder="From"
                minDate={new Date("2000-01-01")}
                maxDate={toDate ? toDate : new Date()}
                onChange={(e) => {
                    const nextFrom = e.target.value;
                    setFromDate(nextFrom);
                    const nextValidTo =
                        nextFrom && toDate && new Date(nextFrom) <= new Date(toDate)
                            ? toDate
                            : null;
                    setToDate(nextValidTo);
                    emitDateChange(nextFrom, nextValidTo);
                }}
                ref={calendarRef}
            />
            <Calendar
                value={toDate}
                placeholder="To"
                minDate={fromDate ? fromDate : new Date("2000-01-01")}
                maxDate={new Date()}
                dateFormat="dd/mm/yy"
                onChange={(e) => {
                    const nextTo = e.target.value;
                    setToDate(nextTo);
                    emitDateChange(fromDate, nextTo);
                }}
                ref={calendarRef}
                disabled={!fromDate}
            />
        </div>
    );
}

export default LastUpdatedDateFilter;